(() => {
  const dialog = document.querySelector('[data-quick-dialog]');
  const cartGroup = (item) => String(item?.properties?._mws_cart || item?.properties?.__mws_apo_cart || '');
  const linePlan = (item) => String(item?.selling_plan_allocation?.selling_plan?.id || item?.selling_plan || '');
  let opening = 0, returnFocus, current, editing, editPayment, paymentOperation, loadRequest, readyTimer;

  const waitForApo = async () => {
    const deadline = Date.now() + 12000;
    while (!window.mwApoInit?.apo?.initialized) {
      if (Date.now() > deadline) throw new Error('Options unavailable');
      await new Promise((resolve) => setTimeout(resolve, 100));
    }
    return window.mwApoInit;
  };

  // APO groups identical configurations without considering payment plans.
  // Scope only this configuration operation to lines with its selected plan.
  const beginPayment = (data) => {
    if (!current || data.htmlElements.form !== current.form || paymentOperation) return;
    const plan = new FormData(current.form).get('selling_plan') || '';
    const init = data.initConfig;
    const descriptor = Object.getOwnPropertyDescriptor(init, 'cart');
    if (!descriptor || !('value' in descriptor) || !descriptor.configurable) return;
    const operation = { init, descriptor, raw: init.cart, plan, engraving: current.form.querySelector('[data-engraving-property]')?.value || '', birthstones: current.form.querySelector('[data-birthstone-property]:not(:disabled)')?.value || '', personalization: Object.fromEntries(Array.from(current.form.querySelectorAll('[data-personalization-property]')).map(input => [input.name.slice(11,-1),input.disabled?'':input.value])) };
    paymentOperation = operation;
    Object.defineProperty(init, 'cart', {
      configurable: true, enumerable: descriptor.enumerable,
      get() {
        const cart = operation.raw || { items: [] };
        const groups = new Set(cart.items.filter((item) => !item.properties?._mws_option && linePlan(item) === plan && String(item.properties?.Engraving || '') === operation.engraving && String(item.properties?._joa_birthstone_ids || '') === operation.birthstones && Object.entries(operation.personalization).every(([key,value])=>String(item.properties?.[key]||'')===value)).map(cartGroup));
        const items = cart.items.filter((item) => item.properties?._mws_option ? groups.has(cartGroup(item)) : linePlan(item) === plan && String(item.properties?.Engraving || '') === operation.engraving && String(item.properties?._joa_birthstone_ids || '') === operation.birthstones && Object.entries(operation.personalization).every(([key,value])=>String(item.properties?.[key]||'')===value));
        return { ...cart, items, item_count: items.reduce((count, item) => count + item.quantity, 0) };
      },
      set(cart) { operation.raw = cart; }
    });
    current.paymentPlan = plan;
    current.form.querySelectorAll('[name="selling_plan"]').forEach((input) => { input.disabled = true; });
  };
  const finishPayment = () => {
    if (paymentOperation) {
      const { init, descriptor, raw } = paymentOperation;
      Object.defineProperty(init, 'cart', { ...descriptor, value: raw });
      paymentOperation = null;
    }
    current?.form.querySelectorAll('[name="selling_plan"]').forEach((input) => { input.disabled = false; });
  };


  const updateEditorAmounts = panel => {
    const price = panel.closest('.mw-tingle')?.querySelector('.mw-product-info__price span');
    const raw = price?.textContent.replace(/[^0-9.,]/g, '') || '';
    if (!raw) return;
    const base = /[.,][0-9]{2}$/.test(raw) ? Number(raw.replace(/[^0-9]/g, '')) : Number(raw.replace(/[^0-9]/g, '')) * 100;
    const extra=editing?.birthstoneTotal||0;const total=base+extra;
    if (!Number.isFinite(total) || total <= 0) return;
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: panel.dataset.currency });
    const setAmount = (element, cents, suffix = '') => {
      const value = money.format(cents / 100) + (suffix ? ' ' + suffix : '');
      if (element && element.textContent !== value) element.textContent = value;
    };
    setAmount(panel.querySelector('[data-joa-editor-full]'), total);
    panel.querySelectorAll('[data-deposit-rate]').forEach(input => {
      const rate=Number(input.dataset.depositRate);const eligible=(editing?.birthstoneProperties?._joa_birthstone_plans||'').split(',').includes(input.value);
      const due = Math.round(base * rate) + (eligible?Math.round(extra*rate):extra);
      const label = input.closest('label');
      setAmount(label.querySelector('[data-joa-editor-now]'), due, panel.dataset.now);
      setAmount(label.querySelector('[data-joa-editor-later]'), total - due, panel.dataset.later);
    });
    window.JoaOptionDesign?.enhance(panel.closest('.mw-apo-container'), document.querySelector('[data-joa-global-option-copy]'), true);
  };
  const mountEditorPayment = payload => {
    if (!editing || String(payload?.cartId) !== editing.group || !editing.paymentTemplate) return;
    const options = payload.htmlElements?.options?.querySelector('.mw-apo-container') || payload.htmlElements?.options;
    const modal = options?.closest('.mw-tingle');
    if (!modal || modal.querySelector('[data-joa-editor-payment]')) return;
    const panel = editing.paymentTemplate.content.firstElementChild?.cloneNode(true);
    if (!panel || !options) return;
    const summary = options.querySelector('.joa-design-summary');
    if (summary) summary.before(panel);
    else options.append(panel);
    editing.panel = panel;modal.dataset.joaBirthstoneTotal=String(editing.birthstoneTotal||0);modal.dataset.joaBirthstonePlans=editing.birthstoneProperties?._joa_birthstone_plans||'';
    const saveButton = modal.querySelector('.tingle-modal-box__footer .btn--primary');
    if (saveButton) {
      editing.submitObserver = new MutationObserver(() => {
        if (panel.disabled && !saveButton.classList.contains('mw-apo-in-progress')) finishEditPayment();
      });
      editing.submitObserver.observe(saveButton, { attributes: true, attributeFilter: ['class'] });
    }
    panel.querySelectorAll('[data-joa-editor-plan]').forEach(input => { input.checked = input.value === editing.plan; });
    updateEditorAmounts(panel);
    const price = modal.querySelector('.mw-product-info__price');
    if (price) {
      editing.priceObserver = new MutationObserver(() => updateEditorAmounts(panel));
      editing.priceObserver.observe(price, { childList: true, subtree: true, characterData: true });
    }
    const state = editing;
    requestAnimationFrame(() => requestAnimationFrame(() => {
      if (editing !== state || !panel.isConnected) return;
      const content = modal.querySelector('.tingle-modal-box__content');
      if (!content) return;
      content.scrollTo({ top: state.focusPayment ? content.scrollHeight : 0, behavior: 'instant' });
      if (state.focusPayment) panel.querySelector('[data-joa-editor-plan]:checked')?.focus({ preventScroll: true });
    }));
  };
  const finishEditPayment = () => {
    if (editing?.panel) editing.panel.disabled = false;
    editPayment = null;
  };

  // The native cart editor rebuilds lines via Storefront or Ajax. Preserve the
  // existing plan for the exact edited parent, leaving every other line alone.
  const preserveEditPayment = (body) => {
    if (!editPayment || typeof body !== 'string') return body;
    let data;
    try { data = JSON.parse(body); } catch { return body; }
    let changed = false;
    for (const item of data.items || []) {
      if (!item.properties?._mws_option && cartGroup(item) === editPayment.group) {
        for (const [key, value] of Object.entries(editPayment.birthstoneProperties || {})) item.properties[key] = key==='_joa_birthstone_ids'?JSON.stringify(window.JoaBirthstones.valid(value)):value;
        if(editPayment.quantity)item.quantity=editPayment.quantity;
        if (editPayment.engraving) item.properties.Engraving = editPayment.engraving;
        else delete item.properties.Engraving;
        if (editPayment.plan) item.selling_plan = editPayment.plan;
        else delete item.selling_plan;
        changed = true;
      }
    }
    if (typeof data.query === 'string' && data.query.includes('cartLinesAdd')) {
      for (const line of data.variables?.lines || []) {
        const properties = Object.fromEntries((line.attributes || []).map(({ key, value }) => [key, value]));
        if (!properties._mws_option && cartGroup({ properties }) === editPayment.group) {
          line.attributes = (line.attributes || []).filter(attribute => attribute.key !== 'Engraving');
          for (const [key, value] of Object.entries(editPayment.birthstoneProperties || {})) { line.attributes = line.attributes.filter(a => a.key !== key); line.attributes.push({key,value:key==='_joa_birthstone_ids'?JSON.stringify(window.JoaBirthstones.valid(value)):value}); }
          if(editPayment.quantity)line.quantity=editPayment.quantity;
          if (editPayment.engraving) line.attributes.push({key:'Engraving',value:editPayment.engraving});
          if (editPayment.plan) line.sellingPlanId = `gid://shopify/SellingPlan/${editPayment.plan}`;
          else delete line.sellingPlanId;
          changed = true;
        }
      }
    }
    return changed ? JSON.stringify(data) : body;
  };
  const isCartRequest = (url) => {
    try {
      const target = new URL(url, location.origin);
      return (target.origin === location.origin && /\/cart\/add\.js$/.test(target.pathname) && target.searchParams.get('app') === 'mws_apo') ||
        (target.hostname === window.mwApoInit?.shop_domain && /\/api\/[^/]+\/graphql\.json$/.test(target.pathname));
    } catch { return false; }
  };
  const originalFetch = window.fetch;
  window.fetch = function (input, init) {
    if (editPayment && isCartRequest(typeof input === 'string' ? input : input?.url) && init?.body) init = { ...init, body: preserveEditPayment(init.body) };
    return originalFetch.call(this, input, init);
  };
  const xhrOpen = XMLHttpRequest.prototype.open;
  const xhrSend = XMLHttpRequest.prototype.send;
  const xhrUrls = new WeakMap();
  XMLHttpRequest.prototype.open = function (method, url) {
    xhrUrls.set(this, url);
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    const preserved=editPayment && isCartRequest(xhrUrls.get(this)) ? preserveEditPayment(body) : body;
    return xhrSend.call(this,isCartRequest(xhrUrls.get(this))?window.JoaBirthstones?.prepare(preserved)||preserved:preserved);
  };

  const setQuickFeedback = (state, feedback) => {
    state.feedback = feedback;
    const title = state.root.querySelector('h2')?.textContent || '';
    const jewelry = /bracelet|necklace|earring|^custom (?:engraving|pav[eé] initials)$/i.test(title);
    state.root.querySelectorAll('[data-joa-quick-feedback]').forEach(button => {
      button.dataset.joaCartState = feedback;
      button.querySelector('[data-joa-loading-label]').textContent = jewelry ? button.dataset.itemLoading : button.dataset.ringLoading;
      button.setAttribute('aria-busy', String(feedback === 'loading'));
      if (feedback === 'success') {
        button.dataset.added = 'true';
        button.setAttribute('aria-label', button.dataset.addedLabel);
      } else {
        button.removeAttribute('data-added');
        button.removeAttribute('aria-label');
      }
    });
  };
  const startQuickFeedback = state => {
    if (state.feedback === 'loading') return;
    state.startedAt = Date.now();
    setQuickFeedback(state, 'loading');
    state.status.textContent = '';
  };
  const flyQuickItem = async state => {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!customElements.get('fly-to-cart')) {
      try { await import('@theme/fly-to-cart'); } catch { return; }
    }
    if (current !== state || !dialog.open) return;
    const source = [...state.root.querySelectorAll('[data-joa-quick-feedback]')].find(button => {
      const rect = button.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight;
    });
    const destination = document.querySelector('.header-actions__cart-icon');
    if (!source || !destination) return;
    const flight = document.createElement('fly-to-cart');
    flight.className = 'fly-to-cart--quick';
    const image = state.root.querySelector('.joa-quick-ring__summary img');
    if (image?.currentSrc) flight.style.setProperty('background-image', `url(${JSON.stringify(image.currentSrc)})`);
    else {
      const icon = source.querySelector('.add-to-cart-icon svg');
      if (!icon) return;
      flight.classList.add('joa-cart-flight-fallback');
      flight.append(icon.cloneNode(true));
    }
    flight.style.setProperty('--start-opacity', '0');
    flight.source = source;
    flight.destination = destination;
    dialog.append(flight);
  };

  const showError = () => {
    if (!current) return;
    current.root.dataset.quickState = 'error';
    current.form.removeAttribute('aria-busy');
    current.status.textContent = dialog.dataset.error;
    current.status.setAttribute('role', 'alert');
    current.busy = false;
    setQuickFeedback(current, 'idle');
    current.root.querySelectorAll('.joa-quick-ring__submit, .mw-apo-add-to-cart-cloned').forEach((button) => { button.disabled = !current.ready; });
  };
  const enhanceOptions = () => {
    if (!current) return;
    const ids = current.controlIds || (current.controlIds = new Map());
    current.form.querySelectorAll('input[id], select[id], textarea[id]').forEach(control => {
      const original = control.dataset.joaQuickControlId || control.id;
      const unique = `${current.root.id}-${original}`;
      ids.set(original, unique);
      if (control.id !== unique) {
        control.dataset.joaQuickControlId = original;
        control.id = unique;
      }
    });
    current.root.querySelectorAll('[for], [aria-labelledby], [aria-describedby], [aria-controls]').forEach(element => {
      ['for', 'aria-labelledby', 'aria-describedby', 'aria-controls'].forEach(attribute => {
        const value = element.getAttribute(attribute);
        if (!value) return;
        const scoped = value.split(/\s+/).map(id => ids.get(id) || id).join(' ');
        if (scoped !== value) element.setAttribute(attribute, scoped);
      });
    });
    window.JoaOptionDesign?.enhance(current.form.querySelector('.mw-apo-container'), current.root.querySelector('[data-joa-design-copy]'), true);
  };
  const updateDeposit = () => {
    if (!current) return;
    const raw = current.root.querySelector('.joa-quick-ring__price').textContent.replace(/[^0-9.,]/g, '').replace(/,/g, '');
    const total = Number(raw);
    if (!Number.isFinite(total) || total <= 0) return;
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: current.root.dataset.currency });
    const stones = current.form.querySelector('joa-birthstones');
    const extra = (stones?.total?.() || 0) / 100;
    const full = current.root.querySelector('[data-quick-full-now]');
    if (full) full.textContent = `${money.format(total + extra)} ${dialog.dataset.now}`;
    current.root.querySelectorAll('[data-deposit-rate]').forEach((input) => {
      const due = (Math.round(total * Number(input.dataset.depositRate) * 100) + (stones?.due?.(Number(input.dataset.depositRate), input.value) || 0)) / 100;
      const amounts = input.nextElementSibling;
      amounts.querySelector('[data-quick-due-now]').textContent = `${money.format(due)} ${dialog.dataset.now}`;
      amounts.querySelector('[data-quick-due-later]').textContent = `${money.format(total + extra - due)} ${dialog.dataset.later}`;
    });
    enhanceOptions();
  };
  document.addEventListener('joa:birthstones-change', () => { if (current) updateDeposit(); });
  const submit = async (event) => {
    event.preventDefault();
    const state = current;
    if (!state?.ready || state.busy) return;
    const data = new FormData(state.form);
    if (!data.get('properties[_mws_cart]') && !data.get('properties[__mws_apo_cart]')) return showError();
    const plan = state.paymentPlan ?? data.get('selling_plan') ?? '';
    data.delete('selling_plan');
    if (plan) data.set('selling_plan', plan);
    const sections = [...new Set(Array.from(document.querySelectorAll('cart-items-component')).map((element) => element.dataset.sectionId).filter(Boolean))];
    if (sections.length) data.set('sections', sections.join(','));
    state.busy = true;
    startQuickFeedback(state);
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', body: data, headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error('Cart rejected the configuration');
      const remaining = Math.max(0, 650 - (Date.now() - state.startedAt));
      if (remaining) await new Promise(resolve => setTimeout(resolve, remaining));
      if (current !== state) return;
      setQuickFeedback(state, 'success');
      flyQuickItem(state).catch(() => {});
      document.dispatchEvent(new CustomEvent('joa:cart-add-confirmed', { detail: { handle: state.handle } }));
      try {
        const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
        const cart = await cartResponse.json();
        const { CartLinesUpdateEvent } = await import('@shopify/events');
        state.form.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(data.get('id')), quantity: 1 }], promise: Promise.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { source: 'joa-quick-add', itemCount: 1, sections: result.sections, didError: false } }) }));
      } catch { /* View cart always opens the saved server cart. */ }
      await new Promise(resolve => setTimeout(resolve, 1600));
      if (current !== state) return;
      state.root.querySelector('.joa-quick-ring__body').hidden = true;
      state.root.querySelector('.joa-quick-ring__success').hidden = false;
      state.root.querySelector('.joa-quick-ring__success a').focus();
      state.busy = false;
    } catch { showError(); }
  };

  const open = async (link) => {
    if (!dialog || current?.busy || paymentOperation) return;
    const generation = ++opening;
    returnFocus = link;
    loadRequest?.abort();
    clearTimeout(readyTimer);
    current?.observer?.disconnect();
    current?.optionsObserver?.disconnect();
    current = null;
    const loading = document.querySelector('[data-quick-loading]');
    if (!loading) return;
    dialog.replaceChildren(loading.content.cloneNode(true));
    dialog.querySelector('[data-quick-load-details]').href = link.href;
    dialog.setAttribute('aria-busy', 'true');
    if (!dialog.open) dialog.showModal();
    dialog.querySelector('[data-quick-close]').focus();
    try {
      const url = new URL(link.href, location.origin);
      if (url.origin !== location.origin || !url.pathname.includes('/products/')) throw new Error('Invalid product');
      url.searchParams.delete('view');
      url.searchParams.set('section_id', 'joa-quick-add');
      const request = new AbortController();
      loadRequest = request;
      const timeout = setTimeout(() => request.abort(), 15000);
      let html;
      try {
        const response = await fetch(url.href, { credentials: 'same-origin', signal: request.signal });
        if (!response.ok) throw new Error('Product unavailable');
        html = await response.text();
      } finally { clearTimeout(timeout); }
      if (generation !== opening || !dialog.open) return;
      const template = new DOMParser().parseFromString(html, 'text/html').querySelector('template[id^="JoaQuick-"]');
      if (!template?.content.querySelector('form')) throw new Error('Options unavailable');
    dialog.replaceChildren(template.content.cloneNode(true));
    const root = dialog.querySelector('.joa-quick-ring');
    root.id = `${template.id}-active-${generation}`;
    const form = root.querySelector('form');
    current = { root, form, handle: url.pathname.split('/products/')[1]?.split('/')[0], status: root.querySelector('[data-quick-status]'), ready: false, busy: false };
    form.addEventListener('submit', submit);
    form.addEventListener('change', enhanceOptions);
    dialog.removeAttribute('aria-busy');
    root.querySelector('[data-quick-close]').focus();
      const init = await waitForApo();
      if (generation !== opening || !dialog.open) return;
      const options = root.querySelector('[data-quick-options]');
      const product = JSON.parse(options.dataset.mwProduct);
      const selector = `#${root.id}`;
      options.id = `${root.id}-options`;
      const config = { ...init, product, response: {}, lock_cart_ids: {}, settings: { ...init.settings, selectors: { ...init.settings.selectors, place_options: `#${options.id}`, price: `${selector} .joa-quick-ring__price`, form: `${selector} form`, variants: `${selector} input[name="id"]`, gallery_container: '', gallery_image: '' } } };
      options.removeAttribute('data-mw-apo-s-container');
      options.setAttribute('data-mw-apo-process', String(Date.now()));
      init.apo.initInline({ container: root, options, form, variants: [form.querySelector('[name="id"]')], quantity: form.querySelector('[name="quantity"]'), price: [root.querySelector('.joa-quick-ring__price')], add_to_cart: [form.querySelector('.joa-quick-ring__submit')] }, config);
      current.observer = new MutationObserver(updateDeposit);
      current.observer.observe(root.querySelector('.joa-quick-ring__price'), { childList: true, subtree: true, characterData: true });
      updateDeposit();
      readyTimer = setTimeout(() => { if (generation === opening && current && !current.ready) showError(); }, 15000);
    } catch (error) {
      console.warn('[ring-configurator] Could not load options:', error);
      if (generation !== opening || !dialog.open) return;
      dialog.removeAttribute('aria-busy');
      if (current) showError();
      else {
        const status = dialog.querySelector('[data-quick-load-status]');
        status.textContent = dialog.dataset.error;
        status.setAttribute('role', 'alert');
      }
    }
  };
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('[data-quick-ring]');
    if (link && dialog && event.button === 0 && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
      event.preventDefault();
      // Native card navigation must not follow the product link after opening.
      event.stopImmediatePropagation();
      const drawer = link.closest('header-drawer');
      const details = drawer?.querySelector('details[open]');
      if (details && typeof drawer.close === 'function') {
        const observer = new MutationObserver(() => {
          if (!details.open) { observer.disconnect(); open(link); returnFocus = details.querySelector('summary'); }
        });
        observer.observe(details, { attributes: true, attributeFilter: ['open'] });
        drawer.close();
      } else open(link);
      return;
    }
    if (event.target.closest('[data-quick-close]') && !current?.busy && !paymentOperation) dialog?.close();
    const paymentShortcut = event.target.closest('[data-joa-payment-edit]');
    const edit = paymentShortcut
      ? paymentShortcut.closest('.cart-items__table-row')?.querySelector('.joa-cart-edit-options')
      : event.target.closest('[data-mw-apo-cart-id]');
    if (edit?.classList.contains('joa-cart-edit-options')) {
      // Open our trigger through APO's native API once and report load failures.
      // Avoid a second invocation by the app's document-level click helper.
      event.preventDefault();
      event.stopImmediatePropagation();
      if (edit.disabled) return;
      editing?.priceObserver?.disconnect();
      editing?.submitObserver?.disconnect();
      editPayment = null;
      editing = { group: edit.dataset.mwApoCartId, plan: edit.dataset.joaSellingPlan || '', engraving: edit.dataset.joaEngraving || '', birthstoneProperties: { ...JSON.parse(edit.dataset.joaBirthstones || '{}'), ...JSON.parse(edit.dataset.joaPersonalization || '{}') }, paymentTemplate: edit.parentElement.querySelector('[data-joa-cart-payment-template]'), focusPayment: Boolean(paymentShortcut) };
      editing.quantity=Number(edit.dataset.joaQuantity)||1;editing.birthstoneTotal=(window.JoaBirthstones?.valid(editing.birthstoneProperties._joa_birthstone_ids).length||0)*Number(edit.dataset.joaBirthstoneUnit||0);
      edit.disabled = true;
      edit.setAttribute('aria-busy', 'true');
      if (paymentShortcut) { paymentShortcut.disabled = true; paymentShortcut.setAttribute('aria-busy', 'true'); }
      edit.parentElement.querySelector('[data-joa-edit-error]')?.remove();
      let observer, deadline;
      const finish = (failed = false) => {
        observer?.disconnect();
        clearTimeout(deadline);
        edit.disabled = false;
        edit.removeAttribute('aria-busy');
        if (paymentShortcut) { paymentShortcut.disabled = false; paymentShortcut.removeAttribute('aria-busy'); }
        if (failed) {
          const error = document.createElement('p');
          error.setAttribute('role', 'alert');
          error.dataset.joaEditError = '';
          error.textContent = edit.dataset.joaError;
          edit.after(error);
        }
      };
      waitForApo().then((init) => {
        observer = new MutationObserver(() => {
          if (document.querySelector('.mw-tingle .mw-apo-container')) finish();
        });
        observer.observe(document.body, { childList: true, subtree: true });
        deadline = setTimeout(() => finish(true), 15000);
        init.apo.initConfigureLinks(edit, init);
      }).catch(() => finish(true));
    }
  }, true);
  document.addEventListener('joa:apo', ({ detail: { name, payload } }) => {
    if (name === 'init::finish') mountEditorPayment(payload);
    if (name === 'init::finish' && payload?.htmlElements?.form === current?.form && current) {
      clearTimeout(readyTimer);
      current.optionsObserver?.disconnect();
      current.optionsObserver = new MutationObserver(enhanceOptions);
      const options = current.form.querySelector('.mw-apo-container');
      if (options) current.optionsObserver.observe(options, { childList: true, subtree: true });
      enhanceOptions();
      current.ready = true;
      current.root.dataset.quickState = 'ready';
      current.form.removeAttribute('aria-busy');
      setQuickFeedback(current, 'idle');
      current.status.textContent = '';
      current.root.querySelectorAll('.joa-quick-ring__submit, .mw-apo-add-to-cart-cloned').forEach((button) => { button.disabled = false; });
      updateDeposit();
    }
    if (name === 'initialize::options::request::failed' && current && String(payload?.productId) === current.root.dataset.productId) showError();
    if (name === 'attachEvents::initAddToCart::clickStart') {
      beginPayment(payload);
      if (current && payload?.htmlElements?.form === current.form) startQuickFeedback(current);
    }
    if (name === 'attachEvents::initAddToCart::clickError' && current && payload?.htmlElements?.form === current.form) showError();
    if (['attachEvents::initAddToCart::clickEnd', 'attachEvents::initAddToCart::clickError'].includes(name)) finishPayment();
    if (name === 'init::insertIntoModal::submitStart' && editing && String(payload?.cartId) === editing.group) {
      const selected = editing.panel?.querySelector('[data-joa-editor-plan]:checked');
      editPayment = { group: editing.group, plan: selected ? selected.value : editing.plan, engraving: editing.engraving, birthstoneProperties: editing.birthstoneProperties,quantity:editing.quantity };
      if (editing.panel) editing.panel.disabled = true;
    }
    if (name === 'init::insertIntoModal::clickEnd' || name === 'init::insertIntoModal::clickError' || name === 'onClick::validate-failed') finishEditPayment();
  });
  window.addEventListener('click', event => {
    if (!event.isTrusted || !current || !event.target.closest?.('[data-joa-quick-feedback]')) return;
    if (current.busy || current.feedback === 'loading' || current.feedback === 'success') {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  dialog?.addEventListener('cancel', (event) => { if (current?.busy || paymentOperation) event.preventDefault(); });
  dialog?.addEventListener('close', () => { ++opening; loadRequest?.abort(); clearTimeout(readyTimer); current?.observer?.disconnect(); current?.optionsObserver?.disconnect(); current = null; dialog.removeAttribute('aria-busy'); returnFocus?.focus(); });
})();




